import React from 'react';
import { TextButton } from '@amzn/storm-ui';
import { useSelector } from 'react-redux';
import { selectPageLayoutType } from 'src/app/slice';
import {
  Copyright,
  DesktopToggleWrap,
  FooterLink,
  FooterLinks,
  FooterWrapper,
} from './Footer.styles';
import { FooterComponentProps } from './Footer.types';

const Desktop: React.VFC<FooterComponentProps> = ({
  copyright,
  links,
  isMobile,
  toggleText,
  toggleView,
  isFooterLinkEnabled,
}) => {
  const pageLayoutType = useSelector(selectPageLayoutType);

  return (
    <FooterWrapper id="footer" pageLayoutType={pageLayoutType}>
      {isFooterLinkEnabled === true && toggleText && toggleView && (
        <DesktopToggleWrap>
          <TextButton style={{ fontSize: '40px' }} onClick={toggleView}>
            {toggleText}
          </TextButton>
        </DesktopToggleWrap>
      )}
      <Copyright type="span">{copyright}</Copyright>
      <FooterLinks isVertical={isMobile}>
        {links &&
          links.map((link) => (
            <FooterLink key={link.label} href={link.url}>
              {link.label}
            </FooterLink>
          ))}
      </FooterLinks>
    </FooterWrapper>
  );
};

export default Desktop;
